export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto w-full">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>高清免费 · 在线不缓冲</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-5">
              糖心视频 · 免费影视在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-heading font-semibold mb-6">
              西瓜视频免费 · 91在线视频 · 电影电视剧免费追
            </p>

            <div className="space-y-3 text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                糖心视频聚合全网热门影视资源，覆盖西瓜视频免费、免费视频网站91、91在线视频等主流平台。
                无论是最新上映的电影大片还是热播电视剧全集，都能在这里高清流畅观看，无需等待缓冲，
                随时随地免费追剧。每日更新片库，综艺、动漫、纪录片一网打尽，追剧不迷路。
              </p>
              <p>
                当前热播专题涵盖悬疑烧脑剧场、国产口碑好剧、海外高分电影，更有每周新番速递和经典回顾专区，
                满足全家人的观影需求。打开糖心视频，好剧立刻看！
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">实时同步</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">高清不缓冲</div>
                <div className="text-xs text-foreground-500 mt-1">流畅观影</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 text-sm md:text-base cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 border-2 border-background-300 text-foreground-700 font-semibold rounded-lg hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 text-sm md:text-base cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20composition%20showing%20a%20modern%20home%20entertainment%20setup%20with%20soft%20ambient%20lighting%2C%20a%20large%20screen%20displaying%20vibrant%20movie%20poster%20collage%20with%20warm%20orange%20and%20amber%20tones%2C%20cozy%20living%20room%20atmosphere%20with%20plush%20seating%2C%20film%20reels%20and%20popcorn%20subtle%20decor%2C%20clean%20modern%20aesthetic%2C%20editorial%20photography%20with%20soft%20highlights%2C%20harmonious%20warm%20color%20palette%2C%20simple%20elegant%20background&width=800&height=600&seq=tangxin-hero-01&orientation=landscape"
                alt="糖心视频 - 高清免费在线观影，家庭影院氛围"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}